module.exports = __webpack_public_path__ + "img/cornerstone.460d147d.png";